import { z } from 'zod';
import { objectId, timestampFields, FieldMetadata } from './base';

/**
 * PushToken Schema
 * One Expo push token per installed device, owned by a User. Upserted by the
 * mobile app after login (POST /pushTokens), removed on logout or when Expo
 * reports DeviceNotRegistered during a send.
 */
export const PushTokenSchema = z.object({
  _id: objectId,
  user: objectId,
  token: z.string().min(1),
  platform: z.enum(['ios', 'android']).optional(),
  deviceId: z.string().optional(),
  ...timestampFields,
});

export type PushToken = z.infer<typeof PushTokenSchema>;

export const pushTokenMetadata: Record<string, FieldMetadata> = {
  _id: { hidden: true },
  user: { ref: 'User', label: 'User' },
  token: { label: 'Expo Push Token' },
  platform: { label: 'Platform' },
  deviceId: { label: 'Device' },
  created: { hidden: true },
  updated: { hidden: true },
};
